/**
 * @generated SignedSource<<bd467bf05916c8ed6c09b392d18c2276>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionHeaderFeaturesArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
      readonly published: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "sectionHeaderFeaturesArticle";
};
export type sectionHeaderFeaturesArticle$key = {
  readonly " $data"?: sectionHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sectionHeaderFeaturesArticle"
};

(node as any).hash = "e14ea5b2919955c02dda8bc2c08ac1ec";

export default node;
